import React, { useContext } from "react"
import { Container } from "@inlet/react-pixi"
import { GameContext } from "utils/game-context"
import { lines } from "global.js"
import Line from "components/line"

const Lines = () => {
  const context = useContext(GameContext)
  const { showedLines, activeLine } = context.state
  return (
    <Container>
      {showedLines.map(line => (
        <Line data={lines[line]} active={line === activeLine} key={line} />
      ))}
    </Container>
  )
}

export default Lines
